import {AppVersion} from '../../types/AppVersion';
import {AppFeature, AppWorksWith} from '../../types/AppConstants';
import {AppFilterStrategy} from './AppFilterStrategy';

/**
 * Filter strategy for filtering apps by Works With.
 * Checks if the app's categories array includes the specified Works With value for Opal
 * and shows all apps for CMS except for two specific apps.
 */
export class WorksWithFilterStrategy extends AppFilterStrategy<AppWorksWith> {
  public matches(app: AppVersion, filterValue: AppWorksWith | undefined): boolean {
    if (!this.isActive(filterValue)) {
      return true;
    }

    // Special case for CMS: shows all apps expect for two
    if (filterValue === AppWorksWith.CMS) {
      if (
        app.id.app_id === 'experimentation_sync_app' ||
        app.id.app_id === 'file_export' ||
        app.features?.some((f) => f === AppFeature.OPAL_TOOL_APP)
      ) {
        return false;
      } else {
        return true;
      }
    }

    if (!app.metadata.categories) {
      return false;
    }

    return app.metadata.categories.includes(filterValue!);
  }
}
